import { KeyRoundIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { useCurrentUserOrNull } from '@/shared/auth';
import { Button } from '@/shared/ui/button';

/**
 * Asks a user who still has an initial password (`mustChangePassword`: the administrator of a new installation, whose
 * password was generated on the server) to choose an own one. The link opens the change-password dialog on the own
 * profile; the banner disappears once the password is changed.
 */
export function PasswordChangeBanner() {
  const { t } = useTranslation('app');
  const user = useCurrentUserOrNull();
  if (!user?.mustChangePassword) return null;

  return (
    <div
      role="status"
      className="mb-4 flex flex-col gap-3 rounded-lg border border-warning/30 bg-warning-soft px-4 py-3 text-sm sm:flex-row sm:items-center"
      data-testid="password-change-banner"
    >
      <KeyRoundIcon className="hidden size-5 shrink-0 text-warning-text sm:block" aria-hidden />
      <span className="min-w-0 flex-1">
        <span className="block font-medium text-foreground">{t('passwordChange.title')}</span>
        <span className="block text-muted-foreground">{t('passwordChange.text')}</span>
      </span>
      <Button asChild size="sm" variant="outline" className="shrink-0 self-start sm:self-auto">
        <Link
          to={`/company/users/${encodeURIComponent(user.id)}?changePassword=1`}
          data-testid="password-change-open"
        >
          {t('passwordChange.action')}
        </Link>
      </Button>
    </div>
  );
}
